import { NgModule } from "@angular/core";
import { TableModule } from "primeng/table";
import { ToolbarModule } from "primeng/toolbar";
import { ButtonModule } from "primeng/button";
import { DialogModule } from "primeng/dialog";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { ToastModule } from "primeng/toast";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { InputTextModule } from "primeng/inputtext";
import { TooltipModule } from "primeng/tooltip";
import { GenericDialogComponent } from "../../shared/generic-dialog/generic-dialog.component";
import { DropdownModule } from "primeng/dropdown";
import { ChipsModule } from "primeng/chips";
import { TabViewModule } from 'primeng/tabview';
import { SpinnerServiceComponent } from '../../shared/spinner-service/spinner-service.component';
import { InputNumberModule } from "primeng/inputnumber";
import { TributosHistoricoComponent } from './tributos-historico/tributos-historico.component';
import { TributosPagarComponent } from './tributos-pagar/tributos-pagar.component';
import { TributosRoutingModule } from './tributos-routing.module';


@NgModule({
  declarations: [
    TributosHistoricoComponent,
    TributosPagarComponent
  ],
  imports: [
    TributosRoutingModule,
    TableModule,
    ToolbarModule,
    ButtonModule,
    DialogModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    ToastModule,
    ConfirmDialogModule,
    InputTextModule,
    TooltipModule,
    GenericDialogComponent,
    DropdownModule,
    SpinnerServiceComponent,
    ChipsModule,
    TabViewModule,
    InputNumberModule,
  ]
})
export class TributosModule { }